import styled from "styled-components";

export const FreeToPlayAnimatedIconDefaultBox = styled.div<{isHybridEmbedded: boolean}>`
    position: fixed;
    cursor: pointer;
    z-index: 4;
    bottom: ${props => props.isHybridEmbedded? 'calc(env(safe-area-inset-bottom) + 56px)' : '0px'};
    right: 0;
`;
